import { useState } from 'react';
import { IDiameterCheckboxDropdown } from '../interfaces/diameter-checkbox-dropdown.interface';
import { FeatureFilter } from '../models/feature-filter.model';

export const ProductFiltersUseBetween = () => {
    const [selectedNpsAndDnDiameter, setSelectedNpsAndDnDiameter] = useState<IDiameterCheckboxDropdown[]>([]);
    const [diameterRangeFromTo, setDiameterRangeFromTo] = useState<number[]>([0, 0]);
    const [diameterMin, setDiameterMin] = useState<number>(0);
    const [diameterMax, setDiameterMax] = useState<number>(0);
    const [diameterList, setDiameterList] = useState<IDiameterCheckboxDropdown[]>([]);
    const [featuresFilters, setFeaturesFilters] = useState<FeatureFilter[]>([]);
    const [currentFeatureId, setCurrentFeatureId] = useState<string>();
    return {
        selectedNpsAndDnDiameter,
        setSelectedNpsAndDnDiameter,
        diameterRangeFromTo,
        setDiameterRangeFromTo,
        diameterMin,
        setDiameterMin,
        diameterMax,
        setDiameterMax,
        diameterList,
        setDiameterList,
        featuresFilters,
        setFeaturesFilters,
        currentFeatureId,
        setCurrentFeatureId,
    };
};
